/* ログインID変更 */
import React, { useState, useEffect } from 'react';
import Block from '../molecules/Block';
import Annotation from '../atoms/Annotation';
import axios from '../axios';
import { Row, Col } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../molecules/LoadingModal';
import { Modal, Button } from 'react-bootstrap';
import { jumpUrl } from './../Common';
import { createRoot } from 'react-dom/client';

const mypage_login_url = '/mypage/login';

const LoginIdComplete: React.FC = () => {
  const [error_message, setErrorMessage] = useState('');
  const [show, setShow] = useState(false);
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
  }, []);
  // キャンセルボタン
  const handleClickCacncel = () => {
    const handleCancel = async () => {
      try {
        //ローディング画面表示
        setIsLoading(true);
        const response = await axios.put('login_id/cancel');
        location.replace(`${location.origin}${process.env.MIX_MOCK_URL}${mypage_login_url}`);
      } catch (error) {
        console.log(error);
        jumpUrl(error.response.data.url);
        setErrorMessage(error.response.data.message);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };

    handleCancel();
  };
  // 確定ボタン
  const handleChangeFix = () => {
    const handleChangeFix = async () => {
      try {
        //ローディング画面表示
        setIsLoading(true);

        const response = await axios.put('login_id/confirm');
        // 完了ダイアログを表示
        setShow(true);
      } catch (error) {
        console.log(error.response);
        if (error.response.status === 401) {
          if (error.response.data.role_error_flg) {
            // 権限エラー (行員のログイン画面へ遷移)
            location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/login`);
          } else {
            // 認証エラー (申込人のログイン画面へ遷移)
            location.replace(`${location.origin}${process.env.MIX_MOCK_URL}${mypage_login_url}`);
          }
        }
        setErrorMessage(error.response.data.message);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };

    handleChangeFix();
  };

  // 完了ダイアログでOKをクリックしたらログイン画面へ遷移
  const handleClickOk = () => {
    setShow(false);
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`);
  };
  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="ログインID変更完了"
        content={
          <>
            <Annotation text="ログインIDの変更を完了するには「確定」ボタンを押下してください。" />
            <Annotation text="ログイン画面が表示されますので、新しいログインIDでログイン操作を行ってください。" />
            <div className="w-75 p-3">{/* 改行 */}</div>
            <Annotation text="ログインIDの変更をキャンセルする場合は、「キャンセル」ボタンを押下してください。" />
            <Annotation text="ログイン画面が表示されますので、変更前のログインIDでログイン操作を行ってください。" />
            <div className="mt-3"></div>
            {typeof error_message !== 'undefined' && (
              // エラー表示
              <Row className="d-flex align-items-center justify-content-center">
                <Col></Col>
                <Col md={9} className="alert-danger alert-danger-custom">
                  {error_message}
                </Col>
              </Row>
            )}
            <div className="row">
              <div className="col-md">
                <div className="p-back-btn-box ">
                  <a className="c-btn btn-large btn-red" onClick={handleClickCacncel}>
                    キャンセル
                  </a>
                </div>
              </div>
              <div className="col-md-4 ms-auto"></div>
              <div className="col-md-auto">
                <div className="p-back-btn-box">
                  <a className="c-btn btn-large btn-main-color" onClick={handleChangeFix}>
                    確定
                  </a>
                </div>
              </div>
            </div>
          </>
        }
      />
      <>
        {/* モーダル */}
        <Modal className="d-flex align-items-center" show={show} animation={false}>
          <Modal.Header>
            <Modal.Title className="dialog-title">ログインIDの変更が完了</Modal.Title>
          </Modal.Header>
          <Modal.Body className="dialog-body">ログインIDの変更が完了しました。</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClickOk}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      </>
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};
const container = document.getElementById('common-login-id-complete');
if (container) {
  const root = createRoot(container);
  root.render(<LoginIdComplete />);
}
